import React, { Component } from 'react';
import styles from './Policy.module.scss'


class PolicyPage extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div className={styles.backgroundWrap}>
                <div className={`${styles.formWrap}`}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default PolicyPage;
